import React, { useState, useEffect, memo } from "react"
import { Tooltip } from "antd"
import "./Comparator.scss"
const Comparator = (props) => {
  const { value, data } = props
  const { field } = props.colDef
  const [display, setDisplay] = useState(null)

  useEffect(() => {
    let source = data.location_data.source
    let mask = data.location_data.mask
    let ctg = data.location_data.ctg

    let sourceVal = null
    let ctgVal = null
    let maskVal = null
    if (source && source[field]) {
      sourceVal = source[field]
    }
    if (ctg && ctg[field]) {
      ctgVal = ctg[field]
    }
    if (mask && mask[field]) {
      maskVal = mask[field]
    }

    let component = processValues(sourceVal, ctgVal, maskVal)
    setDisplay(component)
  }, [value, data])

  const processValues = (source, ctg, mask) => {
    if (mask !== undefined && mask !== null && ctg) {
      // if MASK + CTG data is available
      if (mask == ctg) {
        // if MASK + CTG data is equal
        return getComponent(
          mask,
          "masked",
          "Value Overriden Source Value: " + source + "; MASK value = CTG value",
          true
        )
      } else {
        // if MASK + CTG data is NOT equal
        let maskComponent = getComponent(mask, "masked", "Value Overriden Source Value: " + source, true)
        let ctgComponent = getComponent(ctg, "ctg-only", "CTG value")
        return [maskComponent, ctgComponent]
      }
    } else if (mask !== undefined && mask !== null) {
      // only MASK data
      return getComponent(mask, "masked", "Value Overriden Source Value: " + source, true)
    } else if (ctg && source) {
      // if Source + CTG data is available
      if (ctg.toString() == source.toString()) {
        // if Source + CTG data is equal
        return getComponent(source, "equal", "Prime value = CTG value")
      } else {
        // if Source + CTG data is NOT equal
        let sourceComponent = getComponent(source, "source-only", "Prime value")
        let ctgComponent = getComponent(ctg, "ctg-only", "CTG Value")
        return [sourceComponent, ctgComponent]
      }
    } else if (source) {
      // if Source data only
      return getComponent(source, "source-only", "Prime value")
    } else if (ctg) {
      // if CTG data only
      return getComponent(ctg, "ctg-only", "CTG Value")
    }
    return null
  }

  const getComponent = (value = "", type, tooltip, showMask = false) => {
    const getColor = (type) => {
      switch (type) {
        case "ctg-only":
          return "comparator-ctg-only"
        case "source-only":
          return "comparator-source-only"
        case "masked":
          return "comparator-masked"
        default:
          return "comparator-default"
      }
    }
    const getTextDecoration = (type) => {
      if (type === "ctg-only") return "ctg-only-text-decoration"
      return "default"
    }

    return (
      <Tooltip title={<div className="comparator-info-container">{tooltip}</div>}>
        <div className={`comparator-text  ${getColor(type)} ${getTextDecoration(type)}`}>
          {showMask && <div className="fas fa-eye comparator-mask-icon" />}
          {value}
        </div>
      </Tooltip>
    )
  }

  return <div className="comparator-container">{display}</div>
}

export default memo(Comparator)
